module.exports = __webpack_public_path__ + "static/media/info_1.936afbb2.jpg";